// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".debugger .push-bottom[data-v-28d0b6d6]{margin-bottom:40px}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Admin/Debugger.vue"],"names":[],"mappings":"AAGE,wCACE,kBAFJ","sourcesContent":["\n\n.debugger\n  .push-bottom\n    margin-bottom: 40px\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
